module.exports = __webpack_public_path__ + "media/images/athletes/1594-eefb48906def9a3318940df9a5ec8504.png";